import React from 'react';
import { array } from 'prop-types';
import CardFenomene from './../../fenomene_selection/components/CardFenomene';
import ButtonBoxIcon from './ButtonBoxIcon';
import {Grid} from '@material-ui/core';

import { connect } from 'react-redux';

const CharacteristicSelector = ({data, onContCh, filterArray, title}) =>{
    const handleClick = (value,id,group) =>{
        onContCh(value,id,group);
    }

    const getClass = (item) => {
        let type = item.group.split('_')
        for(let i=0; i<filterArray.length; i++){
            if(filterArray[i].name === type[type.length-1]){
                if(filterArray[i].value === item.value && filterArray[i].id === item.id)
                    return 'btnCharacteristicsOn'
            }
        }
        return 'btnCharacteristicsOff'
    }

    //Mapeo de GrupoEtario y se almacena el elemento en item
    const leer = () => {
        return(
            data.map(item =>(
                    <Grid key={`${item.icon}_${item.title}_${item.id}_${item.value}`} className="iconContainerFS" >
                        <ButtonBoxIcon
                                icon = {item.icon}
                                group = {item.group}
                                id= {item.id}
                                value = {item.value}
                                Seleccion = {handleClick}
                                classSelected = {getClass(item)}
                            />
                    </Grid>   
                    )
                )
            )
        }


        return(
            <Grid>
                 <CardFenomene
                        title = {title} 
                        groupbutton = {leer()}
                        />
            </Grid>
        )
}

CharacteristicSelector.propTypes = {
    data: array,
}


function mapStateToProps(state) {
    return {
        filterArray: state.dashboard.filterArray
    }
}

export default connect(mapStateToProps)(CharacteristicSelector);